import { noop } from 'lodash'
import { type FC, StrictMode } from 'react'
import { Button, ButtonSize } from '@opallabs/lapidary'
import * as styles from './styles'
import * as Table from './Table'
import { Titles } from './Titles'
import { type PairingFormProps, type SerializedData } from './types'
import { usePairingFormState } from './useFormState'

export { type PairingFormProps, type SerializedData }

const AddOptionButton: FC = () => {
  const { addBlankEntry, isReadonly } = usePairingFormState()

  if (isReadonly) return null

  return (
    <Button
      name="Add Item"
      onClick={addBlankEntry}
      size={ButtonSize.Small}
      variant="secondary"
    >
      Add Item
    </Button>
  )
}
AddOptionButton.displayName =
  'AdminConfiguration: AddOptionButton ← PairingForm ← CustomFields'

export const PairingForm: FC = () => {
  const { entries } = usePairingFormState()

  return (
    <StrictMode>
      <form css={styles.form} method="dialog" onSubmit={noop}>
        <Titles />

        <Table.Root>
          {entries.map((option) => (
            <Table.Row key={option.pseudoId} option={option} />
          ))}

          <AddOptionButton />
        </Table.Root>
      </form>
    </StrictMode>
  )
}
PairingForm.displayName = 'AdminConfiguration: PairingForm ← CustomFields'
